<template>
  <!-- <div class="detail-subject">
        <BreadcrumClass />
        <div class="container">
            <div class="row"> -->
                <!-- <div class="col-lg-4 col-md-4 col-12 detail-left">
                    <div class="item-class display-flex">
                        <div class="info-left display-flex">
                            <img src="@/assets/img/icon-list.png" alt />
                            <div class="info-class text-left">
                                <h2 class="primary-color font-sanpro-semibold font-size-16">Lớp 1A - Môn Tiếng Việt</h2>
                                <h3
                                    class="secondary-color-txt font-family-Semibold font-size-14"
                                >Trường Tiểu học Nguyễn Tất Thành</h3>
                                <h3 class="secondary-color-txt font-family-Semibold font-size-14">Mã lớp: <router-link class="primary-color font-sanpro-semibold font-size-14" to="/lop-hoc/ma-lop">ABC123XYZ</router-link></h3>
                            </div>
                        </div>
                    </div>
                    <div class="status-join display-flex">
                        <div class="form-group select-status">
                            <select class="form-control" id="status">
                                <option>Đã tham gia</option>
                                <option>Chưa tham gia</option>
                                <option>Đã hoàn thành</option>
                            </select>
                            <i class="fa fa-angle-down"></i>
                        </div>
                        <div class="dropdown dropdown-account">
                            <button
                                type="button"
                                id="dropdownMenuButton"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                                class="dropdown-toggle"
                            >
                                <i class="fas fa-ellipsis-h"></i>
                            </button>
                            <div aria-labelledby="dropdownMenuButton" class="dropdown-menu">
                                <a href="javascript:;" class="dropdown-item" role="button">Xem thông tin</a>
                                <a href="javascript:;" class="dropdown-item" role="button">Rời lớp</a>
                                <a href="javascript:;" class="dropdown-item" role="button">Báo cáo</a>
                            </div>
                        </div>
                    </div>
                    <div class="menu-tabs">
                            <router-link :to="{name: 'ViewDetailSubject'}" class="">Nội dung môn học</router-link>
                            <router-link to="/lop-hoc/thao-luan" class="">Thảo luận</router-link>
                            <router-link to="/lop-hoc/lich" class="active">Lịch</router-link>
                            <router-link :to="{name: 'ViewDocument'}" class="">Tài liệu</router-link>
                    </div>
                </div> -->
                <div class="col-lg-8 col-md-8 col-12 detail-right" :class="{'col-lg-12': nameRoute=='user-profile'}">

                    <div class="search display-flex justify-content-between">
                        <div class="form" v-if="nameRoute !='user-profile'">
                            <form class="form-training">
                                <input type="text" placeholder="Tìm kiếm" required="required" />
                                <button type="submit">
                                    <i class="fa fa-search secondary-color-blue"></i>
                                </button>
                            </form>
                        </div>
                        <!-- <div class="form-group select-status">
                            <select class="form-control" id="status">
                                <option>Tất cả thành viên</option>
                                <option>Chưa tham gia</option>
                                <option>Đã hoàn thành</option>
                            </select>
                            <i class="fa fa-angle-down"></i>
                        </div> -->
                    </div>
                    <!-- <button  class="btn-main btn-add btn-radius-20"><i class="icon-Cng-1"></i> Thêm mới</button>     -->
                    <!-- {{getListEvent}} -->
                    <!-- <button class="btnAdd font-size-14 color-light " ><i class="fal fa-plus"></i>&ensp;Thêm mới</button> -->
                    <div class="add-code">
                        <button
                          type="button"
                          class="btn btn-primary btns add-btn-primary add-btn-primary-private font-family-Semibold display-flex-center justify-content-center"
                        >
                          <i class="fal fa-plus margin-right-fa-plus"></i> Thêm mới
                        </button>
                      </div>
                   	<full-calendar :config="config" :events="events" />
                     
                        <!-- <FullCalendar 
                        :config="config"
                        :plugins="calendarPlugins"
                        :locale="vi"
                        :header="{
                            left:'title',
                            center:'dayGridMonth, timeGridWeek, timeGridDay, listWeek', 
                            right: 'prev today next',
                        }"
                        :buttonText="{
                            today:'Hôm nay',
                            month:'Tháng',
                            week:'Tuần',
                            day:'Ngày',
                            list: 'Lịch'
                            }"
                            :selecttable="true"
                            :events="EVENTS"
                        /> -->

                         <!-- <div class='demo-app'>
                            <div class='demo-app-top'>
                            <button @click="toggleWeekends">toggle weekends</button>
                            <button @click="gotoPast">go to a date in the past</button>
                            (also, click a date/time to add an event)
                            </div>
                            <FullCalendar
                            class='demo-app-calendar'
                            ref="fullCalendar"
                            defaultView="dayGridMonth"
                            :header="{
                                left: 'prev,next today',
                                center: 'title',
                                right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek'
                            }"
                            :plugins="calendarPlugins"
                            :weekends="calendarWeekends"
                            :events="calendarEvents"
                            @dateClick="handleDateClick"
                            />
                        </div> -->
                        <!-- {{getDetailEvent}} -->
                         <b-modal v-if="getDetailEvent" size="lg" v-model="modalShow" id="my-modal">
                           <div class="modal-header ">
                               <h4 class="font-size-16 primary-color-txt font-sanpro-semibold">{{moment(getDetailEvent.timeBegin).format(formatDate1)}} </h4>
                               <i @click="closeModal" class="fas fa-times-circle four-color"></i>
                           </div>
                           <div class="modal-body1">
                                <hr>
                               <span class="secondary-color-txt font-family-Semibold font-size-14 mr-2">Tiêu đề :</span> 
                               <span class="primary-color-txt font-family-Semibold font-size-14">{{getDetailEvent.title}}</span>
                               <hr>
                               <p class="primary-color-txt font-family-Semibold font-size-14">{{getDetailEvent.content}}</p>
                           </div>
                        </b-modal>
                           <!-- <b-modal id="my-modal">Hello From My Modal!</b-modal> -->
                </div>
            <!-- </div>
        </div>
  </div> -->
</template>

<script>
// require('@fullcalendar/core/main.min.css')
// require('@fullcalendar/daygrid/main.min.css')
// require('@fullcalendar/timegrid/main.min.css')

import { mapActions, mapGetters } from "vuex";
import { STORE_KEY } from "../_store/constants";
import { FullCalendar } from 'vue-full-calendar'
// import FullCalendar from '@fullcalendar/vue'
// import DayGridPlugin from '@fullcalendar/daygrid'
// import TimeGridPlugin from '@fullcalendar/timegrid'
// import InteractionPlugin from '@fullcalendar/interaction'
// import ListPlugin from '@fullcalendar/list'


import moment from "moment";
import "fullcalendar/dist/locale/vi";
import 'fullcalendar/dist/fullcalendar.css'
import BreadcrumClass from "../_components/breadcrumb/BreadcrumbClass"
export default {
    name: "ViewCalendar",
    data(){
        return{
            formatDate1: "DD/MM/YYYY",
            classSchoolSubjectId : this.$route.params.id,
            nameRoute : this.$route.name,
            modalShow: false,
            events: [
            ],
            config: {
                defaultView: "month",
                locale: "vi",
                        // defaultView: "month",
        allDaySlot: false,
        eventClick: function(view) {
            this.actionEventDetail(view.eventId)
            this.modalShow = true;
        }.bind(this)
            }
        }
    },
    components: {
        BreadcrumClass,
        FullCalendar
    },
    computed: {
        ...mapGetters({
            getListEvent: STORE_KEY + "/getListEvent",
            getDetailEvent: STORE_KEY + "/getDetailEvent"
        })
    },
    watch:{
        getListEvent(newVal,oldVal){
           newVal.forEach((value, index) => {
                var tmp = {};
                 tmp["eventId"] = value.eventId;
                 tmp["title"] = value.title;
                 tmp["start"] = value.timeBegin;
                 tmp["end"] = value.timeEnd;
                 this.events.push(tmp);
            });
        }
    },
    mounted() {
        if(this.nameRoute !='user-profile'){
              this.actionListEvent({ClassSchoolSubjectId: this.classSchoolSubjectId,TimeBegin:null,TimeEnd:null})
        }
        else{
             this.actionListEventByUser()   
        }
        // console.log("ok");
        this.actionGetListSubjectInWeek();
    },
    methods: {
        moment,
        ...mapActions(`${STORE_KEY}`, ["actionGetListSubjectInWeek","actionListEvent","actionEventDetail","actionListEventByUser"]),
        moment,
         next() {
            this.$refs.calendar.fireMethod('next')
        },
        closeModal(){
             this.modalShow = false;
        },
        eventClick: function(view) {
            this.modalShow = true;
            // console.log("áđâsđâsđâsđâsđâsđâsd", this.modalShow)
        }.bind(this),
        changeView(view) {
            this.$refs.calendar.fireMethod('changeView', view)
        },
        removeEvents() {
            this.$refs.calendar.$emit('remove-event')
        },
        addEvents() {
            this.$refs.calendar.$emit('render-event')
        },


        // toggleWeekends() {
        // this.calendarWeekends = !this.calendarWeekends // update a property
        // },
        // gotoPast() {
        // let calendarApi = this.$refs.fullCalendar.getApi() // from the ref="..."
        // calendarApi.gotoDate('2000-01-01') // call a method on the Calendar object
        // },
        // handleDateClick(arg) {
        //     if (confirm('Would you like to add an event to ' + arg.dateStr + ' ?')) {
        //         this.calendarEvents.push({ // add new event data
        //         title: 'New Event',
        //         start: arg.date,
        //         allDay: arg.allDay
        //         })
        //     }
        // }
    }
}

</script>

<style lang="scss" scoped>
.fc-icon::after {
    content: '<i class="fas fa-angle-right"></i>' 
    !important;
} 
.fc-icon-left-single-arrow:after {
    content: '<i class="fas fa-angle-right"></i>' !important;
    font-weight: bold;
    font-size: 200%;
    top: -7%;
}
.modal-header {
    .close {
        position: absolute;
        right: 14px !important;
        top: 1.0rem;
        padding: 0.5rem;
        color: #000;
        z-index: 9999;
    }
}

.modal-body1{
  padding: 0px 20px 0px 20px !important;
   border-radius: 15px !important;
}
.modal-content{
     border-radius: 15px !important;
}
.modal-header{
    padding: 20px 20px 0px 20px !important;
    //  border-bottom: 1px solid red !important;
     border-radius: 15px !important;
}
    button.fc-prev-button.fc-button.fc-state-default.fc-corner-left,
    button.fc-next-button.fc-button.fc-state-default.fc-corner-right {
        border-radius: 50%;
        height: 30px;
        width: 30px;
        border: 0;
        color: #124ABE !important;
        background: #e1efff;
    }
    .fc-center{
        h2{
            color:red !important;
        }
    }
    .fc-event, .fc-event-dot {
    background-color: #e1efff;
    }
    .fc-content {
    background-color: #e1efff !important;
    color: #0f3dba !important;
    /* border: none; */
    border-radius: 5px !important;
    border: 1px solid #e1efff !important;
}
    .fc-right{
        display: none !important;
    }

    .search{
        margin-bottom:30px;
    }
    .dropdown-account{
        margin-left: 10px;
    }
    .dropdown button {
        width: 30px;
        background:#f3f6fb;
        color: #879AA9;
        font-size: 14px;
        text-align: center;
        border: 0px;
        padding-left: 0px;
        padding-right: 0px;
        border-radius: 30px;
        height: 30px;
        outline: 0;
    }
    .dropdown-item:hover,
    .dropdown-item:focus {
        color: #124abe;
        text-decoration: none;
        background: #f3f6fb;
    }
    .dropdown button:focus {
        background: #f3f6fb !important;
        color: #124ABE;
    }
    .dropdown-toggle::after {
        display:none;
    }
    .dropdown-menu {
        padding: 0rem 0 0.5rem;
        margin: 0.125rem 0 0;
        box-shadow: 1px -1px 7px rgba(0, 0, 0, 0.3);
        transform: translate3d(-95px, 30px, 0px) !important;
    }
    @media (max-width: 425px){
        .dropdown-menu {
            padding: 0rem 0 0.5rem;
            margin: 0.125rem 0 0;
            box-shadow: 1px -1px 7px rgba(0, 0, 0, 0.3);
            transform: translate3d(167px, 30px, 0px) !important;
        }
    }
</style>